module.exports = __webpack_public_path__ + "static/media/iconExpiryMessage.a3033017.svg";